import { render, staticRenderFns } from "./StateTransitionCreate.vue?vue&type=template&id=6988a36c&"
import script from "./StateTransitionCreate.vue?vue&type=script&lang=js&"
export * from "./StateTransitionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports